import { render, staticRenderFns } from "./RelacaoNotasFiscais.vue?vue&type=template&id=4b85c6be&"
import script from "./RelacaoNotasFiscais.vue?vue&type=script&lang=js&"
export * from "./RelacaoNotasFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports